export default __webpack_public_path__ + "static/sun-chasers-desktop-e670dee10a59b51cfa83a49c127bde1b.webp";